var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "brandable-modal-page" }, [
    _c("div", { staticClass: "images-container" }, [
      _c("div", { staticClass: "floating-editor" }, [
        _c(
          "div",
          {
            staticClass: "arrow-container",
            on: {
              click: function() {
                _vm.collapsed = !_vm.collapsed
              }
            }
          },
          [
            _c("div", {
              staticClass: "arrow",
              class: _vm.collapsed ? "right" : "left"
            })
          ]
        ),
        _vm._v(" "),
        !_vm.collapsed
          ? _c("div", { staticClass: "floating-edit-options" }, [
              _c("div", { staticClass: "floating-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "fixed-container clickable",
                    on: {
                      click: function() {
                        _vm.collapsedNotes = !_vm.collapsedNotes
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "https://cdn.shopify.com/s/files/1/1363/8433/files/editicon_blue.svg?v=1711657195"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("Add Design Note")]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "arrow",
                      class: _vm.collapsedNotes ? "down" : "up"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.collapsedNotes,
                        expression: "!collapsedNotes"
                      }
                    ]
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.designNotes,
                          expression: "designNotes"
                        }
                      ],
                      staticStyle: { width: "100%", resize: "none" },
                      attrs: {
                        placeholder: "Please add instructions",
                        type: "text"
                      },
                      domProps: { value: _vm.designNotes },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.designNotes = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "floating-container clickable",
                  on: {
                    click: function($event) {
                      return _vm.alignLogo(_vm.currentDesignIndex)
                    }
                  }
                },
                [_vm._m(0)]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "exit",
          on: {
            click: function($event) {
              return _vm.goBack()
            }
          }
        },
        [_vm._v("< BACK")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "title-container mobile" }, [
        _c("p", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.selectedAddon.title) + " "),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "turnaround" }, [
            _vm._v("This item typically has a 2-4 week turnaround")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "information-container" }, [
          _c(
            "div",
            {
              staticClass: "information-toggle",
              class: _vm.showDesc ? "toggle" : "",
              on: {
                click: function() {
                  _vm.showDesc = !_vm.showDesc
                }
              }
            },
            [
              _c("span", [_vm._v("Product Information ")]),
              _vm._v(" "),
              _c("div", {
                staticClass: "arrow",
                class: !_vm.showDesc ? "down" : "up"
              })
            ]
          ),
          _vm._v(" "),
          _vm.showDesc
            ? _c("div", { staticClass: "desc-outer-container" }, [
                _c("p", {
                  staticClass: "desc",
                  domProps: { innerHTML: _vm._s(_vm.productDesc) }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showDesc ? _c("div", { staticClass: "curtain" }) : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "image-outer-container" }, [
        _c(
          "div",
          {
            staticClass: "main-image-container",
            attrs: { id: "draggableContainer" }
          },
          [
            _c("img", {
              staticClass: "main-image",
              attrs: { src: _vm.currentMainImage.src }
            }),
            _vm._v(" "),
            _vm.currentDesign && _vm.currentDesign.file
              ? _c(
                  "div",
                  {
                    staticClass: "image-editor-container",
                    class: _vm.designs[_vm.currentDesignIndex].shape
                      ? _vm.designs[_vm.currentDesignIndex].shape
                      : "",
                    attrs: { id: "iContainer" },
                    on: {
                      mouseover: function($event) {
                        _vm.designs[_vm.currentDesignIndex].active = true
                      },
                      mouseleave: function($event) {
                        return _vm.deactivateDesign()
                      }
                    }
                  },
                  [
                    _c(
                      "DDR",
                      {
                        attrs: {
                          id: "ddr",
                          active: _vm.designs[_vm.currentDesignIndex].active,
                          parent: false
                        },
                        on: { click: _vm.activateDesign },
                        model: {
                          value: _vm.designs[_vm.currentDesignIndex].transform,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.designs[_vm.currentDesignIndex],
                              "transform",
                              $$v
                            )
                          },
                          expression: "designs[currentDesignIndex].transform"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "edit-image",
                          attrs: { src: _vm.currentDesign.img }
                        })
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm.currentImageList.length > 1
          ? _c("div", { staticClass: "image-selectors" }, [
              _c(
                "button",
                {
                  staticClass: "image-back",
                  on: {
                    click: function($event) {
                      return _vm.changeImageIndex(false)
                    }
                  }
                },
                [_vm._v("<")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "image-fw",
                  on: {
                    click: function($event) {
                      return _vm.changeImageIndex(true)
                    }
                  }
                },
                [_vm._v(">")]
              )
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "customization-container" },
      [
        _c("div", { staticClass: "title-container desktop" }, [
          _c("p", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.selectedAddon.title) + " "),
            _c("br"),
            _vm._v(" "),
            _c("span", { staticClass: "turnaround" }, [
              _vm._v("This item typically has a 2-4 week turnaround")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "information-container" }, [
            _c(
              "div",
              {
                staticClass: "information-toggle",
                class: _vm.showDesc ? "toggle" : "",
                on: {
                  click: function() {
                    _vm.showDesc = !_vm.showDesc
                  }
                }
              },
              [
                _c("span", [_vm._v("Product Information ")]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "arrow",
                  class: !_vm.showDesc ? "down" : "up"
                })
              ]
            ),
            _vm._v(" "),
            _vm.showDesc
              ? _c("div", { staticClass: "desc-outer-container" }, [
                  _c("p", {
                    staticClass: "desc",
                    domProps: { innerHTML: _vm._s(_vm.productDesc) }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showDesc ? _c("div", { staticClass: "curtain" }) : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _vm.designs.length > 0
          ? _c(
              "div",
              { staticClass: "design-container" },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("1. Upload your designs")
                ]),
                _vm._v(" "),
                _vm._l(_vm.designs, function(design, i) {
                  return _c("div", { staticClass: "design-input-container" }, [
                    _c("input", {
                      staticClass: "file-uploader",
                      attrs: { id: "file" + design.imgIndex, type: "file" },
                      on: {
                        change: function($event) {
                          return _vm.designUpload($event, i)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "outer-label",
                        attrs: { for: "file" + design.imgIndex }
                      },
                      [
                        !design.file
                          ? _c("div", { staticClass: "inner-label" }, [
                              _c("span", { staticClass: "main-text" }, [
                                _vm._v(
                                  " \n                            Upload " +
                                    _vm._s(design.name) +
                                    " Design "
                                ),
                                _c("img", {
                                  attrs: {
                                    src:
                                      "https://cdn.shopify.com/s/files/1/1363/8433/files/upload_purple.svg?v=1710535518"
                                  }
                                })
                              ])
                            ])
                          : _c("div", { staticClass: "inner-label" }, [
                              _c("span", [
                                _c("strong", [
                                  _vm._v(_vm._s(design.name) + ":")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "main-text" }, [
                                _vm._v(_vm._s(design.fileName))
                              ])
                            ])
                      ]
                    ),
                    _vm._v(" "),
                    design.file
                      ? _c(
                          "p",
                          {
                            staticClass: "clear-image",
                            on: {
                              click: function($event) {
                                return _vm.clearImage(i)
                              }
                            }
                          },
                          [_vm._v("X")]
                        )
                      : _vm._e()
                  ])
                }),
                _vm._v(" "),
                _vm._m(1)
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasVariants && _vm.colorOptions
          ? _c("div", { staticClass: "color-container" }, [
              _c("p", { staticClass: "title" }, [_vm._v("2. Choose Color")]),
              _vm._v(" "),
              _c("div", { staticClass: "variant-container" }, [
                _c(
                  "div",
                  { staticClass: "colors-button-container" },
                  _vm._l(_vm.colorOptions.values, function(variant, i) {
                    return _c("div", {
                      key: variant,
                      staticClass: "round-color",
                      class:
                        _vm.optionsSelected[_vm.colorOptions.position - 1] ==
                        variant
                          ? "selected"
                          : "",
                      style: "background:" + _vm.colors[variant.toLowerCase()],
                      on: {
                        click: function($event) {
                          return _vm.selectVariant(
                            _vm.colorOptions.position - 1,
                            variant
                          )
                        }
                      }
                    })
                  }),
                  0
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.nonColorOptions, function(option, i) {
          return _vm.hasVariants
            ? _c("div", { staticClass: "option-container" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(_vm.colorOptions ? 3 + i : 2 + i) +
                      ". Choose Available " +
                      _vm._s(option.name)
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "variants-button-container" },
                  _vm._l(option.values, function(variant, i) {
                    return _c(
                      "button",
                      {
                        key: variant,
                        staticClass: "happybox-button white",
                        class:
                          _vm.optionsSelected[option.position - 1] == variant
                            ? "selected"
                            : "",
                        on: {
                          click: function($event) {
                            return _vm.selectVariant(
                              option.position - 1,
                              variant
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(variant) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._m(2, true)
              ])
            : _vm._e()
        }),
        _vm._v(" "),
        _vm.hasSizes && _vm.qtySizes
          ? _c("div", { staticClass: "sizes-container" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v(
                  "4. Set Sizes and Quantity (Minimum:" +
                    _vm._s(_vm.qtyMin) +
                    ")"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "no-size" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.noSizes,
                      expression: "noSizes"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.noSizes)
                      ? _vm._i(_vm.noSizes, null) > -1
                      : _vm.noSizes
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.noSizes,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.noSizes = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.noSizes = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.noSizes = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "I don't know the sizes. (Don't worry you can contact us later via email)"
                  )
                ])
              ]),
              _vm._v(" "),
              !_vm.noSizes
                ? _c(
                    "div",
                    { staticClass: "sizes-selection-container" },
                    _vm._l(_vm.metafields.brandable_variant_size, function(
                      size,
                      i
                    ) {
                      return _c("div", { staticClass: "size-selection" }, [
                        _c("p", [_vm._v(_vm._s(size))]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.qtySizes[i].qty,
                              expression: "qtySizes[i].qty"
                            }
                          ],
                          attrs: { min: "0", type: "number" },
                          domProps: { value: _vm.qtySizes[i].qty },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.qtySizes[i],
                                "qty",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    }),
                    0
                  )
                : _c("div", { staticClass: "sizes-selection-container" }, [
                    _c("div", { staticClass: "size-selection" }, [
                      _c("p", [_vm._v("Qty")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedQty,
                            expression: "selectedQty"
                          }
                        ],
                        attrs: { min: "0", type: "number" },
                        domProps: { value: _vm.selectedQty },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.selectedQty = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
              _vm._v(" "),
              _c("p", { staticClass: "total-qty" }, [
                _vm._v("Total of "),
                _c(
                  "span",
                  { class: _vm.currentSelectedQty < _vm.qtyMin ? "red" : "" },
                  [_vm._v(_vm._s(_vm.currentSelectedQty))]
                ),
                _vm._v(
                  " " +
                    _vm._s(_vm.selectedAddon.title) +
                    " (MIN:" +
                    _vm._s(_vm.qtyMin) +
                    ")"
                )
              ])
            ])
          : _c("div", { staticClass: "sizes-container" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v(
                  _vm._s(
                    _vm.hasVariants ? (_vm.colorOptions ? "4" : "3") : "2"
                  ) +
                    ". Set Quantity (Minimum:" +
                    _vm._s(_vm.qtyMin) +
                    ")"
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sizes-selection-container" }, [
                _c("div", { staticClass: "size-selection" }, [
                  _c("p", [_vm._v("Qty")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedQty,
                        expression: "selectedQty"
                      }
                    ],
                    attrs: { min: "0", type: "number" },
                    domProps: { value: _vm.selectedQty },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.selectedQty = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "total-qty" }, [
                _vm._v("Total of "),
                _c(
                  "span",
                  { class: _vm.currentSelectedQty < _vm.qtyMin ? "red" : "" },
                  [_vm._v(_vm._s(_vm.currentSelectedQty))]
                ),
                _vm._v(
                  " " +
                    _vm._s(_vm.selectedAddon.title) +
                    " (MIN:" +
                    _vm._s(_vm.qtyMin) +
                    ")"
                )
              ])
            ]),
        _vm._v(" "),
        _vm.extraInputs.length > 0
          ? _c("div", { staticClass: "inputs-container" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v("Additional Customization")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-selection-container" },
                _vm._l(_vm.extraInputs, function(input) {
                  return _c("div", { staticClass: "input-selection" }, [
                    _c("p", [_vm._v(_vm._s(input.name))]),
                    _vm._v(" "),
                    input.inputType === "checkbox"
                      ? _c(
                          "input",
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: input.value,
                                  expression: "input.value"
                                }
                              ],
                              class: input.inputType,
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(input.value)
                                  ? _vm._i(input.value, null) > -1
                                  : input.value
                              },
                              on: {
                                change: function($event) {
                                  var $$a = input.value,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          input,
                                          "value",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          input,
                                          "value",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(input, "value", $$c)
                                  }
                                }
                              }
                            },
                            "input",
                            input.properties,
                            false
                          )
                        )
                      : input.inputType === "radio"
                      ? _c(
                          "input",
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: input.value,
                                  expression: "input.value"
                                }
                              ],
                              class: input.inputType,
                              attrs: { type: "radio" },
                              domProps: { checked: _vm._q(input.value, null) },
                              on: {
                                change: function($event) {
                                  return _vm.$set(input, "value", null)
                                }
                              }
                            },
                            "input",
                            input.properties,
                            false
                          )
                        )
                      : _c(
                          "input",
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: input.value,
                                  expression: "input.value"
                                }
                              ],
                              class: input.inputType,
                              attrs: { type: input.inputType },
                              domProps: { value: input.value },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(input, "value", $event.target.value)
                                }
                              }
                            },
                            "input",
                            input.properties,
                            false
                          )
                        )
                  ])
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "mobile-sticky" }, [
          _c("p", { staticClass: "product-total" }, [
            _c("span", [_vm._v("Total:")]),
            _c("span", [_vm._v("$ " + _vm._s(_vm.currentPrice))])
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "happybox-button green border",
              class: _vm.isLoading ? "isLoading" : "",
              attrs: { disabled: !_vm.canAdd },
              on: { click: _vm.updateMainAddonProductQuantity }
            },
            [
              _vm._v(
                _vm._s(_vm.isLoading ? "loading..." : "Add to Cart & Continue")
              )
            ]
          )
        ])
      ],
      2
    ),
    _vm._v(" "),
    _vm.showColorModal
      ? _c("div", { staticClass: "color-modal" }, [
          _c("div", { staticClass: "color-modal-container" }, [
            _c("p", { staticClass: "title" }, [_vm._v("Backup Color")]),
            _vm._v(" "),
            _c("p", { staticClass: "subtitle" }, [
              _vm._v(
                "You have selected " +
                  _vm._s(_vm.currentSelectedColor) +
                  " color. Please select 2 backup colors you'd be happy with."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "main-container" }, [
              _c("div", { staticClass: "current-pick" }, [
                _c("div", { staticClass: "title" }, [
                  _c("span", [_vm._v("Current Pick")]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "round-color",
                    style:
                      "background:" +
                      _vm.colors[_vm.currentSelectedColor.toLowerCase()]
                  })
                ]),
                _vm._v(" "),
                _c("img", { attrs: { src: this.currentImageList[0].src } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "color-pick" }, [
                _vm.hasVariants && _vm.colorOptions
                  ? _c("div", { staticClass: "variant-container" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("Select back up color options")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "colors-button-container" },
                        _vm._l(_vm.sColors, function(variant, i) {
                          return _c("div", {
                            key: variant,
                            staticClass: "round-color",
                            class: _vm.secondaryColors.includes(variant)
                              ? "selected"
                              : "",
                            style:
                              "background:" + _vm.colors[variant.toLowerCase()],
                            on: {
                              click: function($event) {
                                return _vm.selectReplacementColor(variant)
                              }
                            }
                          })
                        }),
                        0
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _c("p", { staticClass: "final-design" }, [
                    _vm._v(
                      "Don't worry! We'll confirm your final design before it goes into production"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "color-results" }, [
                    _c(
                      "div",
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _vm._l(_vm.secondaryColors, function(variant, i) {
                          return _c("div", {
                            staticClass: "round-color",
                            style:
                              "background:" + _vm.colors[variant.toLowerCase()]
                          })
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "selected-colors" }, [
                      _c("span", { staticClass: "qty" }, [
                        _vm._v(
                          _vm._s(_vm.secondaryColors.length) +
                            "/" +
                            _vm._s(_vm.requiredSecondaryColors)
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.showColorError
              ? _c("p", { staticClass: "red-alert" }, [
                  _vm._v("Please select 2 backups colours in order to proceed.")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "happybox-button",
                class:
                  _vm.secondaryColors.length != _vm.requiredSecondaryColors
                    ? "grey disabled"
                    : "green border",
                on: {
                  click: function($event) {
                    return _vm.finishColors()
                  }
                }
              },
              [_vm._v("Add to Cart & Continue")]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoading
      ? _c("div", { staticClass: "global-spinner-container" }, [
          _c("div", { staticClass: "global-spinner" })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fixed-container" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/align.svg?v=1711657195"
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("Align Logo")]),
      _vm._v(" "),
      _c("div")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "legend" }, [
      _c("img", {
        staticClass: "i-icon",
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/info_icon_462d2e20-cb40-4eb2-9831-90a9babb7cce.svg?v=1700501409"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Max file size is 10mb. Accepted file types are .png, .jpg, .jpeg and .svg"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "legend" }, [
      _c("img", {
        staticClass: "i-icon",
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/info_icon_462d2e20-cb40-4eb2-9831-90a9babb7cce.svg?v=1700501409"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n                    Your design is applied directly onto the products' surface by pushing ink through\n                    a fine mesh screen. This is one of our most popular decoration methods.\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "selected-colors" }, [
      _c("span", [_vm._v("Selected")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }